export default defineNuxtPlugin({
  name: 'gtag',
  parallel: true,
  setup(nuxtApp) {
    if (import.meta.server) {
      return;
    }

    const gtagPromise = new Promise((resolve) => {
      const waitIdle = () =>
        new Promise(r =>
          'requestIdleCallback' in window
            ? requestIdleCallback(() => r(undefined))
            : setTimeout(r, 0),
        );

      nuxtApp.hooks.hookOnce('page:finish', () => {
        void (async () => {
          await waitIdle();

          const { initialize } = useGtag();

          initialize();

          resolve(undefined);
        })();
      });
    });

    nuxtApp.provide('gtagPromise', gtagPromise);
  },
});
